import { render } from "./dailySaleReport.vue?vue&type=template&id=1f6c7a55"
import script from "./dailySaleReport.vue?vue&type=script&lang=js"
export * from "./dailySaleReport.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__